module.exports = __webpack_public_path__ + "static/media/team_03.a16a7635.jpg";